import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/portal/PortalAuth";
import { card } from "@/portal/PortalShell";
import { money } from "@/components/PriceBreakdown";

/** Guest portal: the guest's direct monthly reservations with payment history. */
export function GuestReservations() {
  const [list, setList] = useState(null);
  useEffect(() => {
    api.get("/guest/reservations").then(({ data }) => setList(Array.isArray(data) ? data : [])).catch(() => setList([]));
  }, []);
  if (list === null) return null;
  return (
    <div className={`${card} mt-6`} data-testid="guest-reservations">
      <p className="text-xs tracking-[0.2em] uppercase text-[#8A9A86] font-medium">Monthly reservations & payments</p>
      {list.length === 0 && <p data-testid="guest-reservations-empty" className="mt-3 text-[#78716C] text-sm">No direct reservations linked to your email yet.</p>}
      {list.map((r) => (
        <div key={r.id} data-testid={`guest-res-${r.id}`} className="mt-4 rounded-xl border border-[#E7E5E4] p-4">
          <div className="flex flex-wrap justify-between gap-3">
            <div>
              <p className="text-[#1C1917] font-medium">{r.room_name}</p>
              <p className="text-xs text-[#78716C]">{r.check_in} → {r.check_out} · {r.nights} nights · {r.status}</p>
            </div>
            <div className="text-right text-sm">
              <p data-testid={`guest-res-total-${r.id}`} className="text-[#1C1917]">Total {money(r.total)}</p>
              <p className="text-xs text-[#78716C]">Paid {money(r.amount_paid)} · Balance {money(Math.max(0, r.outstanding_balance ?? 0))}</p>
            </div>
          </div>
          {(r.payments || []).length > 0 && (
            <ul className="mt-3 text-xs text-[#44403C] space-y-1" data-testid={`guest-res-history-${r.id}`}>
              {r.payments.map((p) => (
                <li key={p.id}>{p.kind === "refund" ? "Refund" : `Installment ${p.installment}`} · {money(p.amount)} · {p.status} · {new Date(p.paid_at || p.created_at).toLocaleDateString()}</li>
              ))}
            </ul>
          )}
          {r.next_installment && <p className="mt-2 text-xs text-[#78716C]">Next: {r.next_installment.label} · {money(r.next_installment.amount)} · {r.next_installment.due_label}</p>}
          <Link to={`/pay/${r.id}`} data-testid={`guest-res-open-${r.id}`} className="mt-3 inline-block text-sm underline underline-offset-4 text-[#1C1917]">View invoice, agreement & payments</Link>
        </div>
      ))}
    </div>
  );
}
